import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";



// GET MOTORISTAS PPF
export const getPublicMotoristasPPF = async(token) => {
    const result = await PublicInterceptor(`Logistica/Motoristas/GetMotoristasPPF`, 'GET', {}, token)
    return result;
}